import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { LogOut, Inbox, FolderOpen, MessageSquareQuote, Settings, ImageIcon, Images } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import Seo from "../../components/Seo";
import EnquiriesTab from "./EnquiriesTab";
import ProjectsTab from "./ProjectsTab";
import ReviewsTab from "./ReviewsTab";
import SettingsTab from "./SettingsTab";
import ImagesTab from "./ImagesTab";
import GalleryTab from "./GalleryTab";

const TABS = [
  { id: "enquiries", label: "Enquiries", icon: Inbox },
  { id: "projects", label: "Projects", icon: FolderOpen },
  { id: "photos", label: "Photos", icon: Images },
  { id: "reviews", label: "Reviews", icon: MessageSquareQuote },
  { id: "images", label: "Images", icon: ImageIcon },
  { id: "settings", label: "Settings", icon: Settings },
];

export default function AdminDashboard() {
  const [tab, setTab] = useState("enquiries");
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const doLogout = async () => {
    await logout();
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-paper">
      <Seo title="Admin Dashboard — Razor Build" description="Razor Build admin area." />
      <header className="bg-ink text-white sticky top-0 z-40">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img src="/logo-mark-white.png" alt="Razor Build" className="h-7 w-auto" />
            <span className="font-display font-bold tracking-tight">Razor Build <span className="text-gold font-mono text-[10px] tracking-[0.2em] uppercase ml-1">Admin</span></span>
          </div>
          <div className="flex items-center gap-4">
            <span className="hidden sm:block text-xs text-white/50">{user?.email}</span>
            <button onClick={doLogout} data-testid="admin-logout-btn" className="inline-flex items-center gap-2 font-mono text-[10px] tracking-[0.15em] uppercase text-white/70 hover:text-gold transition-colors">
              <LogOut className="w-4 h-4" /> Logout
            </button>
          </div>
        </div>
        <nav className="border-t border-white/10">
          <div className="max-w-6xl mx-auto px-2 sm:px-6 flex overflow-x-auto">
            {TABS.map((t) => (
              <button
                key={t.id}
                onClick={() => setTab(t.id)}
                data-testid={`admin-tab-${t.id}`}
                className={`flex items-center gap-2 px-4 py-3.5 font-mono text-[11px] tracking-[0.15em] uppercase whitespace-nowrap border-b-2 transition-colors ${tab === t.id ? "border-gold text-white" : "border-transparent text-white/50 hover:text-white"}`}
              >
                <t.icon className="w-4 h-4" /> {t.label}
              </button>
            ))}
          </div>
        </nav>
      </header>
      <main className="max-w-6xl mx-auto px-4 sm:px-6 py-8">
        {tab === "enquiries" && <EnquiriesTab />}
        {tab === "projects" && <ProjectsTab />}
        {tab === "photos" && <GalleryTab />}
        {tab === "reviews" && <ReviewsTab />}
        {tab === "images" && <ImagesTab />}
        {tab === "settings" && <SettingsTab />}
      </main>
    </div>
  );
}
